export const LOGIN_ROUTE = '/';
export const HOME_ROUTE = '/home';
export const CREW_ROUTE = '/crewpage/:id';
export const VEHICLEPAGE_ROUTE = '/vehiclepage/:id';
export const MAINTENANCE_ROUTE = '/maintenances/:id';
export const CREATEVEHICLE_ROUTE = '/createvehicle';
export const CREATEUSER_ROUTE = '/createuser';
export const NEWANNOTATION_ROUTE = '/newannotation/:id';
export const NEWLOG_ROUTE = '/createlog';
export const EDITVEHICLE_ROUTE = '/editvehicle/:id';
export const ADDPREVMAINT_ROUTE = '/addprevmaintenance/:id';
export const EDITSTAFF_ROUTE = '/editstaff/:id';
